import React from "react";

const HotelsSummary = ({ totalHotels }) => {
  if (totalHotels === 0) return null;

  return (
    <div className="mt-6 text-sm text-gray-600 ml-6">
      Total: {totalHotels} hôtel{totalHotels > 1 ? "s" : ""}
    </div>
  );
};

export default HotelsSummary;
